export const pullLotConfirmationType = [
  {
    code: 'Email',
    name: 'Email'
  },
  {
    code: 'Phone',
    name: 'Phone'
  },
  {
    code: 'In Person',
    name: 'In Person'
  }
];
